export enum EventTabColor {
	DEFAULT = '#0050FF',
	ACTIVE = '#637381',
	ERROR = '#F04438',
}
